import React, { Component } from "react";
import { Row, Col, Alert, InputGroup, InputGroupText } from "reactstrap";

import { FetchData } from "../utils/DataFetch";
import { GetCookie, formatCurrency } from "../utils/Common";
import {
  RptChecksReceivedTableDefault,
  columns as rptChecksReceivedColumns,
} from "./RptChecksReceivedTableDefault";
import { LoadingModal } from "../LoadingModal";
import { exportRowsToExcel } from "../utils/ReportExport";
import { ExcelExportButton } from "./ExcelExportButton";

export class RptChecksReceived extends Component {
  static displayName = RptChecksReceived.name;

  constructor(props) {
    super(props);
    this.state = {
      rptChecksReceivedList: [],
      loading: false,
      fetchingData: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      searchModel: {
        StartDate: "",
        EndDate: "",
        StartTime: "",
        EndTime: "",
      },
    };
    this.user = JSON.parse(GetCookie("user"));
    this.clickCount = 0;
    this.singleClickTimer = "";

    this.renderProductionReportTable = this.renderRptChecksReceived.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.exportChecksReceived = this.exportChecksReceived.bind(this);
    //
  }

  componentDidMount() {}

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateRptChecksReceived();
    }
  }

  async populateRptChecksReceived() {
    const { StartDate, EndDate, StartTime, EndTime } = this.state.searchModel;
    if (StartTime && !EndTime) {
      this.setState({
        alert: { color: "warning", message: "End Time is required when Start Time is entered.", isOpen: true },
      });
      return;
    }

    // Times are entered in local time but the DB stores UTC — convert before sending.
    const toUtcTime = (localTimeStr, referenceDateStr) => {
      if (!localTimeStr) return localTimeStr;
      const [hours, minutes] = localTimeStr.split(":").map(Number);
      const d = referenceDateStr ? new Date(referenceDateStr) : new Date();
      d.setHours(hours, minutes, 0, 0);
      return (
        d.getUTCHours().toString().padStart(2, "0") +
        ":" +
        d.getUTCMinutes().toString().padStart(2, "0")
      );
    };

    const searchPayload = {
      ...this.state.searchModel,
      StartTime: toUtcTime(StartTime, StartDate),
      EndTime: toUtcTime(EndTime, EndDate || StartDate),
    };

    this.setState({ fetchingData: true });

    await FetchData(
      "/getrptchecksreceived",
      "POST",
      this.user.token,
      searchPayload
    ).then((data) => {
      this.setState({
        rptChecksReceivedList: data,
        loading: false,
        fetchingData: false,
      });
    });
  }

  exportChecksReceived() {
    exportRowsToExcel({
      rows: this.state.rptChecksReceivedList,
      columns: rptChecksReceivedColumns,
      fileName: "ChecksReceivedReport.xlsx",
    });
  }

  renderRptChecksReceived(rptChecksReceived) {
    return (
      <RptChecksReceivedTableDefault rptChecksReceived={rptChecksReceived} />
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRptChecksReceived(this.state.rptChecksReceivedList)
    );

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Checks Received Report</h5>
        <Row className="align-items-center g-2">
          <Col className="col-3">
            <InputGroup size="sm">
              <InputGroupText>Start Date</InputGroupText>
              <input
                name="StartDate"
                ref={(ref) => (this.txtStartDate = ref)}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.StartDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="Start Date"
                onKeyDown={this.handleKeyDown}
              />
              <InputGroupText>End Date</InputGroupText>
              <input
                name="EndDate"
                ref={(input) => {
                  this.EndDate = input;
                }}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.EndDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="End Date"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
          <Col className="col-3">
            <InputGroup size="sm">
              <InputGroupText>Start Time</InputGroupText>
              <input
                name="StartTime"
                type="time"
                className="form-control form-control-text"
                value={this.state.searchModel.StartTime}
                onChange={this.handleSearchChange}
                onKeyDown={this.handleKeyDown}
              />
              <InputGroupText>End Time</InputGroupText>
              <input
                name="EndTime"
                type="time"
                className="form-control form-control-text"
                value={this.state.searchModel.EndTime}
                onChange={this.handleSearchChange}
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
          <Col className="col-auto">
            <InputGroup size="sm">
              <ExcelExportButton
                onClick={this.exportChecksReceived}
                title="Export Checks Received Report"
              />
            </InputGroup>
          </Col>
        </Row>
        <LoadingModal fetchingData={this.state.fetchingData} />
        <hr />

        <div>{contents}</div>

        {this.state.rptChecksReceivedList?.length > 0 && (
          <div
            className="d-flex justify-content-start p-2"
            style={{ borderTop: '2px solid #ccc', fontWeight: 'bold' }}
          >
            Total Received:{' '}
            {formatCurrency(
              this.state.rptChecksReceivedList.reduce((sum, row) => sum + (row.received ?? 0), 0)
            )}
          </div>
        )}
      </div>
    );
  }
}
